<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Annual Result Bulk Print </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
                            getDiv();
                        " persistent-hint hint="Please select standard" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division"  outlined
                        persistent-hint hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-checkbox class="pl-6 pt-4"
                    v-model="show_hide_percentage"
                    label="Show Parent View"
                  ></v-checkbox>
                  </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Print Marksheet</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            overlay: false,
            selected: [],
            snackbar: false,
            snackbar_msg: "",
            color: "",
            show_hide_percentage:false,
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            fetch_loader: false,
            standard: null,
            division: null,
            academicyear: null,
            org_basic_data: [],
        };
    },

    methods: {
        getreport(){
            localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setstd", this.sel_std_data.std_id);
                localStorage.setItem("setdiv", this.div);
                localStorage.setItem("show_hide_percentage", this.show_hide_percentage);

                if (
                    this.sel_std_data.std == "I" ||
                    this.sel_std_data.std == "II" ||
                    this.sel_std_data.std == "III"
                )
                {
                    let routeData = this.$router.resolve({
                        name: "wws-icsc-annual-bulk-print-I-III",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (
                    this.sel_std_data.std == "Nursery" ||
                    this.sel_std_data.std == "Pre-Nursery" ||
                    this.sel_std_data.std == "Prep"
                )
                {
                    let routeData = this.$router.resolve({
                        name: "wws-icsc-annual-bulk-print-pri-primary",
                    });
                    window.open(routeData.href, "_blank");
                }
                else{
                    let routeData = this.$router.resolve({
                    name: "wws-icsc-annual-bulk-print-IV-X",
                    });
                    window.open(routeData.href, "_blank");
                }
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please Select Proper Data.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            // this.div_list = ["All"];
            // this.div = "All";
            this.div_list = this.sel_std_data.div_list;
            // this.div_list.unshift("All");
            //this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    //this.sel_ay_data = this.ay_std_div_list[0];
                    this.semester_list = res.data.semester_list_wws;
                    this.sem = this.semester_list[2];
                    this.assessment_detail_list = ["All"];
                    this.assessment_detail = "All";
                    this.assessment_detail_list = res.data.assessment_detail_list;
                    this.assessment_detail_list.unshift("All");
                    this.assessment_detail = this.assessment_detail_list[0];
                    this.status_list = res.data.status_list;
                    this.status = this.status_list[0];

                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.onload();


    },
};
</script>
<style scoped>

</style>

